import { Text } from '@blueprintjs/core'
import { usePage } from '@inertiajs/react'
import { CURRENCY_SIGN } from 'lib/constants/currency'
import { ClientLocaleNS } from 'lib/constants/locales'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ClientPageProps } from 'types'

type TProps = {}

type TPageProps = {
  order: Data.Order
} & ClientPageProps

const ProfileOrderPageContent: FC<TProps> = () => {
  const {
    props: { order },
  } = usePage<TPageProps>()

  const { t } = useTranslation(ClientLocaleNS.ProfilePage)

  const date = new Date(order.created_at * 1000).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })

  return (
    <div className="flex flex-1 p-5 gap-5">
      <div className="flex flex-col flex-1 gap-4">
        <Text tagName="span" className="h-8 flex font-body---28px">
          {t('payments.products')}
        </Text>
        <ul className="flex flex-col w-full gap-2">
          {order.orderables.map((item, index) => {
            return (
              <li
                key={item.id}
                className="flex w-full items-center border border-solid border-palette-blue rounded-xl py-2 px-3 gap-3"
              >
                <div className="w-16 h-16 rounded-md overflow-hidden">
                  <img src={item.product.image} className="w-full h-full object-cover"></img>
                </div>
                <a
                  href={`/products/${item.product.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="focus:outline-none flex flex-1"
                >
                  <Text tagName="span" className="font-body---16px">
                    {item.product.name}
                  </Text>
                </a>
                <Text tagName="span" className="font-body---16px">
                  {t('payments.price', { price: item.original_price })}
                </Text>
                <Text tagName="span" className="font-body---16px">
                  {t('payments.quantity', { quantity: item.quantity })}
                </Text>
              </li>
            )
          })}
        </ul>
      </div>
      <div className="flex flex-col w-80 border border-solid border-palette-blue mt-12 rounded-xl max-h-full p-3 gap-2">
        <Text tagName="span" className="font-body---20px">
          {t('payments.order_id', { id: order.id })}
        </Text>
        <Text tagName="span" className="font-body---20px">
          {t('payments.count', { count: order.orderables.length })}
        </Text>
        <Text tagName="span" className="font-body---20px">
          {t('payments.value', { currency_sign: CURRENCY_SIGN, value: order.total })}
        </Text>
        <Text tagName="span" className="font-body---16px text-palette-grey--alt">
          {t('payments.date', { date })}
        </Text>
      </div>
    </div>
  )
}

export { ProfileOrderPageContent }
